<template>
  <v-card class="transparent">
    <notification-card name="Email">
      <template v-slot:content>
        <p>Email notifications will be sent to your inbox</p>
      </template>
      <template v-slot:action>
        <v-switch
          :value="!!user.email_notifications"
          :input-value="!!user.email_notifications"
          class="switch-gradient"
          @change="handleEmailNotifications"
        />
      </template>
    </notification-card>
<!--    <notification-card name="Connected Apps">-->
<!--      <template v-slot:content>-->
<!--        <div class="d-flex">-->
<!--          <img :src="require('@/assets/slack.png')" alt="" class="mr-3">-->
<!--          <div>-->
<!--            <p>Slack</p>-->
<!--            <p>Setup slack notifications to dedicated channels</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
<!--      <template v-slot:action>-->
<!--        <v-btn class="primary-btn white&#45;&#45;text">Setup</v-btn>-->
<!--      </template>-->
<!--    </notification-card>-->
  </v-card>
</template>

<script>
import NotificationCard from './NotificationCard'
import { mapGetters } from 'vuex'
export default {
  name: 'SettingsNotifications',
  components: {
    NotificationCard
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    handleEmailNotifications (shouldSend) {
      const userData = {
        entity_id: this.user.entity_id,
        user_id: this.user.user_id,
        affiliate_id: this.user.affiliate_id,
        email: this.user.email,
        email_verified: this.user.email_verified,
        nickname: this.user.nickname,
        blocked: false,
        name: this.user.name,
        picture: this.user.picture,
        email_notifications: shouldSend,
        eula_accepted: true,
        tour_complete: !!this.user?.tour_complete
      }
      this.$store.dispatch('updateProfile', { data: userData, shouldReload: true })
    }
  }
}
</script>
